import FlexRow from "../../FlexRow.vue";
import FilterSectionTitle from "./FilterSectionTitle.vue";
import WrapWithSection from "./WrapWithSection.vue";
import TrashIcon from "../../icons/TrashIcon.vue";
export default {
  name: "SelectedSection",
  components: {
    FlexRow,
    WrapWithSection,
    FilterSectionTitle,
    TrashIcon
  },
  emits: ["clear", "apply", 'closeDropdown'],
  props: {
    title: {
      type: String,
      default: ""
    },
    count: {
      type: Number,
      default: 0
    },
    isModified: {
      type: Boolean,
      default: false
    },
    searching: {
      type: Boolean,
      default: false
    },
    heightFromTop: {
      type: String,
      default: "0px"
    },
    no_reset: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedTitle() {
      return `${this.title} selected`.toUpperCase();
    }
  }
};